import { Group, GroupItem, Toolbar } from "ra-friendsofbabba";
import React from "react";
import { SimpleForm, required } from "react-admin";
import FileInput from "./inputs/FileInput";
import ProjectDocTypeCustomInput from "./inputs/ProjectDocTypeCustomInput";
import ProjectDocTypeInput from "./inputs/ProjectDocTypeInput";

const Form = (props) => {
  const { record } = props;
  return (
    <SimpleForm
      {...props}
      initialValues={{ ...record }}
      toolbar={
        <Toolbar
          backTab={4}
          backReferenceTarget="project_id"
          backReference="projects"
        />
      }
    >
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <ProjectDocTypeInput
            source="project_doc_type_id"
            validate={required()}
          />
        </GroupItem>
      </Group>
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <ProjectDocTypeCustomInput source="project_doc_type_custom" />
        </GroupItem>
      </Group>

      <FileInput source="media" validate={required()} />
    </SimpleForm>
  );
};
export default Form;
